import { _t } from './base'

export function initGlobal() {
    $('.site-name a').attr('href', '/feelgoodfastfood')

    $('html[lang="en"] .site-name a').attr('href', 'https://www.ristre.com/en/')

    emptyCategory()
    renderReviews()
}

function emptyCategory() {
    const emptyCategory = $('.empty-content-category')
    const newsletterForm = $('footer .subscribe-form')
    const emptyTitle = emptyCategory.find('h2')

    if (emptyCategory.length) {
        emptyTitle.text(_t('category.empty.title'))
        newsletterForm.insertAfter(emptyTitle)
        $(`<p class="empty-content-category__perex">${_t('category.empty.perex')}</p>`).insertAfter(
            emptyTitle
        )
    }
}

export const reviews = [
    {
        image: 'https://www.ristre.com/photo-pg-166---.jpg',
        name: 'Roman Šebrle',
        position: 'olympijský vítěz, TV moderátor',
        text: 'Zdravé jídlo je pro sportovce základ, ale někdy je přes den v televizi tolik práce, že není čas to řešit. Proto jsem si oblíbil RISTRE. Objevil jsem ho při golfu a dnes si ho beru nejen do televize a na delší cesty autem, ale doporučuji ho i svým mladým atletickým svěřencům.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-168---.png',
        name: 'Hynek Čermák',
        position: 'herec a dobrodruh',
        text: 'První ochutnání RISTRE bylo zvláštní. Nejelo mi to. Nepřišel sem na to, s čím tu chuť porovnat.Dal sem načatý sáček do lednice. Studené, je to mnohem lepší. A pak i v pokojové teplotě. Sežral sem celou tu krabici šesti balení za čtyři dny! Je to supr, když člověk hodně maká. Nejím sladké vůbec, ale tohle si dám. Řekl bych, dobrá práce!',
    },
    {
        image: 'https://www.ristre.com/photo-pg-163---.jpg',
        name: 'Marek Dvořák',
        position: 'letecká záchraná služba',
        text: 'RISTRE mě velice mile překvapilo svou chutí i složením. Mám ho u sebe při svém náročném pracovním programu, kdy se může stát, že první jídlo mám až navečer a RISTRE mi pomáhá toto období překonat, aniž bych musel sáhnout třeba k čokoládě nebo fastfoodu, jako jsem to dělal dřív.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-160---.jpg',
        name: 'Markéta Simonová',
        position: 'Eurowings',
        text: 'RISTRE je perfektní na cesty. Je jako obrovská dětská přesnídávka, která se dá pohodlně zavřít a skoro tak i chutná. Jen těch zdravých ingrediencí tam je víc a jsou pro dospělé. Obal je dokonalost sama. Když někam poletíte, vezměte si RISTRE sebou!',
    },
    {
        image: 'https://www.ristre.com/photo-pg-152---.jpg',
        name: 'Jiří Devát',
        position: 'exCEO Microsoft CZ/SK',
        text: 'RISTRE mi do života vneslo řád. Během 25 let v top manažerských rolích jsem poznal, že dobrá životospráva - dostatek spánku a pravidelná vyvážená strava zásadně zvyšují odolnost proti stresu. RISTRE mě zachraňuje v momentech, kdybych jinak tyto zásady porušil.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-180---.jpg',
        name: 'Iveta Kovalová',
        position: 'výživová poradkyně',
        text: 'Jako výživová poradkyně a nadšenec do outdoorových aktivit mohu s čistým svědomím RISTRE doporučit. Je z kvalitních surovin a obsahuje dostatečné množství všech důležitých živin, včetně zdraví prospěšných tuků. RISTRE je pro mě plnohodnotnou náhradou hlavního jídla. Nesmí chybět v mém batohu v přírodě a taky v přihrádce v autě, protože mě vždycky zachrání během hektického dne. Navíc skvěle chutná!',
    },
    {
        image: 'https://www.ristre.com/photo-pg-172---.jpg',
        name: 'Aleš Svoboda',
        position: 'pilot stíhacího letounu Gripen, astronaut ESA',
        text: 'Líbí se mi funkčnost a jednoduchost RISTRE. Mám v něm vše – promyšlené složení,superpotraviny, nutriční hodnoty. Vyhovuje mi jednoduchost skladování a konzumace. Nemusím ho mít v lednici. Dám ho do skříně nebo do batohu a mám ho vždy hned k dispozici. Nemusím nikam nalévat vodu ani nic ohřívat. Jen odšroubuji víčko a můžu jíst. Obal je odolný, takže se nebojím, že se mi náplň někam rozteče.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-183---.jpg',
        name: 'Adéla Maňáková',
        position: 'Krajská nemocnice T. Bati, Zlín',
        text: 'Jako lékařka s náročnými nočními směnami na porodnici a zároveň aktivní sportovkyně jsem velmi náročná na produkty, které používám – potřebuji maximální výkon, spolehlivost a žádné kompromisy. RISTRE mě absolutně nadchlo. Dodává mi energii přesně tehdy, kdy ji potřebuji – ať už ve tři ráno na oddělení, ve fázi intenzivní koncentrace nebo během náročných sportovních výkonů.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-141---.jpg',
        name: 'Martin Šromovský',
        position: '43. výsadkový pluk, Chrudim',
        text: 'Zpočátku jsem RISTRE moc nevěřil. Po testování jsem ale musel změnit názor. Zachutnalo mi a na akci mému tělu poskytlo vše potřebné. Zasytí na několik hodin a člověk se přitom cítí lehký. Jako profesionální voják a výsadkář musím především vyzdvihnout nulovou přípravu. Jen RISTRE vytáhnu a jím. To je geniální a při plnění úkolu to šetří drahocenný čas. Nyní má RISTRE v mém batohu vždy své místo.',
    },
    {
        image: 'https://www.ristre.com/photo-pg-132---.jpg',
        name: 'Michael Boroš',
        position: '8x mistr ČR v cyklokrosu ',
        text: 'RISTRE jsem si vyhledal původně kvůli cestování na dlouhé vzdálenosti mezi závody. Potom jsem ho začal zařazovat i do svých vytrvalostních tréninků. Nezatěžuje, dobře se tráví a navíc ještě doplním všechny super živiny, které obsahuje.',
    },
]
// Funkce na vykreslení recenzí na stránku
function renderReviews() {
    // Najdeme element s třídou 'products'
    const productsElement = document.querySelector('#footer')
    if (productsElement) {
        const reviewsContainer = document.createElement('div')
        reviewsContainer.className = 'swiper-container content wide swiper-ratings'
        const swiperWrapper = document.createElement('div')
        swiperWrapper.className = 'swiper-wrapper'
        reviews.forEach((review) => {
            const reviewSlide = document.createElement('div')
            reviewSlide.className = 'swiper-slide'
            reviewSlide.innerHTML = `
    <div class="reviews-upper">
    <img class="reviews-avatar" src="${review.image}" alt="${review.name}" style="width: 56px; border-radius: 50%; margin-bottom: 10px;">
    <div>
                <h3 class="reviews-header" style="margin: 0 auto;">${review.name}</h3>
        <p class=reviews-work" style="font-size: 13px; opacity: 0.7;">${review.position}</p>
                                    <div class="stars">
    <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
    <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
    <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
    <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
    <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
</div>
            </div>
    </div>
    <p class="reviews-content" style="font-size: 16px; color: #000;">${review.text}</p>
  `
            swiperWrapper.appendChild(reviewSlide)
        })
        reviewsContainer.appendChild(swiperWrapper)
        // Přidání navigačních tlačítek a paginace
        const swiperPagination = document.createElement('div')
        swiperPagination.className = 'swiper-pagination'
        reviewsContainer.appendChild(swiperPagination)
        // Vložíme kontejner s recenzemi hned za element s třídou 'products'
        productsElement.insertAdjacentElement('beforebegin', reviewsContainer)
        // Inicializace Swiperu
        new Swiper('.swiper-container', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
        })
    }
}
